import React, { useState, useRef, useEffect } from "react";
import { logout } from "../../services/oauthService";
import { LogOut } from "lucide-react";

const LOGO_URL = "https://cdn.projurisadv.com.br/interfaces/images/logo-projurisadv-preto.svg";

function getInitials(nome) {
  if (!nome) return "?";
  const parts = nome.trim().split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function UserAvatar({ foto, nome }) {
  const [imgError, setImgError] = useState(false);

  if (foto && !imgError) {
    return (
      <img
        src={foto}
        alt={nome}
        className="w-9 h-9 rounded-full object-cover"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div className="w-9 h-9 rounded-full bg-primary/20 text-primary flex items-center justify-center text-sm font-semibold flex-shrink-0">
      {getInitials(nome)}
    </div>
  );
}

export function Topbar({ userData }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (userData) {
      console.log("[Topbar] userData:", userData);
      console.log("[Topbar] userData.foto:", userData.foto);
    }
  }, [userData]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="h-14 flex items-center justify-between border-b border-border bg-white px-6 flex-shrink-0">
      <img src={LOGO_URL} alt="Projuris ADV" className="h-7" />

      {userData && (
        <div className="relative" ref={dropdownRef}>
          <button
            className="flex items-center gap-2.5 rounded-full px-2 py-1.5 hover:bg-accent transition-colors border-none bg-transparent cursor-pointer"
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            <UserAvatar foto={userData.foto} nome={userData.nome} />
            <span className="text-sm font-medium text-foreground">
              {userData.nome?.trim()}
            </span>
          </button>

          {dropdownOpen && (
            <div className="absolute top-[calc(100%+8px)] right-0 bg-white border border-border rounded-lg shadow-lg min-w-[200px] z-50 overflow-hidden">
              <div className="px-3.5 py-2.5 border-b border-border">
                <p className="text-sm font-semibold text-foreground">{userData.nome?.trim()}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{userData.login}</p>
              </div>
              <button
                className="flex items-center gap-2 w-full px-3.5 py-2.5 text-sm text-foreground hover:bg-accent transition-colors bg-transparent border-none cursor-pointer text-left"
                onClick={() => {
                  setDropdownOpen(false);
                  logout();
                }}
              >
                <LogOut className="w-4 h-4" />
                Sair
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
